'use client';

import { useState } from 'react';
interface PricingProps {
  onRequestDemo: () => void;
}


const Pricing = ({ onRequestDemo }: PricingProps) => {
  const plans = [
    {
      name: 'Starter',
      subtitle: 'For small teams',
      price: 'Free',
      credits: '100 minutes',
      button: 'Start Free Trial',
      features: [
        '100 Minutes',
        '1 Agent',
        '1 User',
        '1 Simultaneous Call',
        'Website Chat',
        'Email Support',
        'Basic Analytics',
        'Pre-built Agent',
      ],
      bg: 'bg-slate-300',
      text: 'text-black',
    },
    {
      name: 'Pro',
      subtitle: 'For growing businesses',
      price: '₹5,000',
      suffix: '/month',
      credits: '400 minutes',
      button: 'Get Started',
      features: [
        '400 Minutes',
        '5 Agents',
        '3 Users',
        '2 Simultaneous Calls',
        'Website Chat',
        'Email + WhatsApp',
        'Call Recording',
        'Fully Customised Agent',
      ],
      bg: 'bg-blue-600',
      text: 'text-white',
    },
    {
      name: 'Business',
      subtitle: 'For scaling teams',
      price: 'Custom',
      credits: 'Custom minutes',
      button: 'Contact Sales',
      features: [
        'Custom Minutes',
        'Unlimited Agents',
        'Unlimited Users',
        'Custom Call Capacity',
        'Website Chat',
        'Email + WhatsApp',
        'Dedicated Manager',
        'Advanced Analytics',
      ],
      bg: 'bg-fuchsia-600',
      text: 'text-white',
    },
  ];

  // Pro selected by default
  const [activePlan, setActivePlan] = useState(1);
  

  return (
    <section data-component-id="src/app/landing-page/components/Pricing.tsx:76:4" data-component-path="src/app/landing-page/components/Pricing.tsx" data-component-line="76" data-component-end-line="180" data-component-file="Pricing.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22pricing%22%2C%22className%22%3A%22py-20%20bg-surface%22%7D" id="pricing" className="py-20 bg-surface">
      <div data-component-id="src/app/landing-page/components/Pricing.tsx:77:6" data-component-path="src/app/landing-page/components/Pricing.tsx" data-component-line="77" data-component-end-line="179" data-component-file="Pricing.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-7xl%20mx-auto%20px-6%22%7D" className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div data-component-id="src/app/landing-page/components/Pricing.tsx:79:8" data-component-path="src/app/landing-page/components/Pricing.tsx" data-component-line="79" data-component-end-line="86" data-component-file="Pricing.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%20mb-16%22%7D" className="text-center mb-16">
          <h2 data-component-id="src/app/landing-page/components/Pricing.tsx:80:10" data-component-path="src/app/landing-page/components/Pricing.tsx" data-component-line="80" data-component-end-line="82" data-component-file="Pricing.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-4xl%20font-bold%20mb-4%22%2C%22textContent%22%3A%22Simple%2C%20Transparent%20Pricing%22%7D" className="text-4xl font-bold mb-4">
            Simple, Transparent Pricing
          </h2>
          <p data-component-id="src/app/landing-page/components/Pricing.tsx:83:10" data-component-path="src/app/landing-page/components/Pricing.tsx" data-component-line="83" data-component-end-line="85" data-component-file="Pricing.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-xl%20text-text-secondary%22%2C%22textContent%22%3A%22Choose%20a%20plan%20that%20fits%20your%20business%20needs%22%7D" className="text-xl text-text-secondary">
            Choose a plan that fits your business needs
          </p>
        </div>

        {/* Pricing Grid */}
        <div data-component-id="src/app/landing-page/components/Pricing.tsx:89:8" data-component-path="src/app/landing-page/components/Pricing.tsx" data-component-line="89" data-component-end-line="178" data-component-file="Pricing.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20md%3Agrid-cols-3%20gap-8%22%7D" className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {plans.map((plan, index) => {
            const isActive = activePlan === index;

            return (
              <div data-component-id="src/app/landing-page/components/Pricing.tsx:94:14" data-component-path="src/app/landing-page/components/Pricing.tsx" data-component-line="94" data-component-end-line="175" data-component-file="Pricing.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
                key={index}
                onMouseEnter={() => setActivePlan(index)}
                onClick={() => setActivePlan(index)}
                className={`relative rounded-2xl cursor-pointer transition-all duration-300
                  ${isActive ? 'scale-105' : 'hover:scale-[1.02]'}
                `}
              >
                {/* Gold Border */}
                {isActive && (
                  <div data-component-id="src/app/landing-page/components/Pricing.tsx:104:18" data-component-path="src/app/landing-page/components/Pricing.tsx" data-component-line="104" data-component-end-line="104" data-component-file="Pricing.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20rounded-2xl%20bg-gradient-to-r%20from-amber-400%20via-yellow-300%20to-amber-500%20p-%5B2px%5D%20shadow-%5B0_0_25px_rgba(245%2C158%2C11%2C0.45)%5D%22%7D" className="absolute inset-0 rounded-2xl bg-gradient-to-r from-amber-400 via-yellow-300 to-amber-500 p-[2px] shadow-[0_0_25px_rgba(245,158,11,0.45)]" />
                )}

                {/* Card */}
                <div data-component-id="src/app/landing-page/components/Pricing.tsx:108:16" data-component-path="src/app/landing-page/components/Pricing.tsx" data-component-line="108" data-component-end-line="174" data-component-file="Pricing.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
                  className={`relative rounded-2xl overflow-hidden bg-white shadow-lg border
                    ${isActive ? 'border-transparent' : 'border-border'}
                  `}
                >
                  {/* Header */}
                  <div data-component-id="src/app/landing-page/components/Pricing.tsx:114:18" data-component-path="src/app/landing-page/components/Pricing.tsx" data-component-line="114" data-component-end-line="130" data-component-file="Pricing.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`${plan.bg} ${plan.text} p-8 text-center`}>
                    <h3 data-component-id="src/app/landing-page/components/Pricing.tsx:115:20" data-component-path="src/app/landing-page/components/Pricing.tsx" data-component-line="115" data-component-end-line="115" data-component-file="Pricing.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-2xl%20font-bold%20mb-1%22%7D" className="text-2xl font-bold mb-1">{plan.name}</h3>
                    <p data-component-id="src/app/landing-page/components/Pricing.tsx:116:20" data-component-path="src/app/landing-page/components/Pricing.tsx" data-component-line="116" data-component-end-line="116" data-component-file="Pricing.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22opacity-90%20mb-6%22%7D" className="opacity-90 mb-6">{plan.subtitle}</p>

                    <div data-component-id="src/app/landing-page/components/Pricing.tsx:118:20" data-component-path="src/app/landing-page/components/Pricing.tsx" data-component-line="118" data-component-end-line="125" data-component-file="Pricing.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-4xl%20font-extrabold%20mb-2%22%7D" className="text-4xl font-extrabold mb-2">
                      {plan.price}
                      {plan.suffix && (
                        <span data-component-id="src/app/landing-page/components/Pricing.tsx:121:24" data-component-path="src/app/landing-page/components/Pricing.tsx" data-component-line="121" data-component-end-line="123" data-component-file="Pricing.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-lg%20font-medium%22%7D" className="text-lg font-medium">
                          {plan.suffix}
                        </span>
                      )}
                    </div>

                    <div data-component-id="src/app/landing-page/components/Pricing.tsx:127:20" data-component-path="src/app/landing-page/components/Pricing.tsx" data-component-line="127" data-component-end-line="129" data-component-file="Pricing.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22inline-block%20mt-4%20px-4%20py-2%20bg-black%2F20%20rounded-lg%20text-sm%22%7D" className="inline-block mt-4 px-4 py-2 bg-black/20 rounded-lg text-sm">
                      {plan.credits}
                    </div>
                  </div>

                  {/* Body */}
                  <div data-component-id="src/app/landing-page/components/Pricing.tsx:133:18" data-component-path="src/app/landing-page/components/Pricing.tsx" data-component-line="133" data-component-end-line="173" data-component-file="Pricing.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22p-8%22%7D" className="p-8">
                    {plan.button === 'Start Free Trial' || plan.button === 'Get Started' ? (
                      <a data-component-id="src/app/landing-page/components/Pricing.tsx:135:22" data-component-path="src/app/landing-page/components/Pricing.tsx" data-component-line="135" data-component-end-line="146" data-component-file="Pricing.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22href%22%3A%22https%3A%2F%2Fdashboard.calltify.com%22%7D"
                        href="https://dashboard.calltify.com"
                        className={`block text-center w-full mb-8 px-6 py-3 rounded-lg font-semibold transition
                          ${
                            isActive
                              ? 'bg-gradient-to-r from-amber-500 to-yellow-400 text-black'
                              : 'bg-gray-800 text-white/90 hover:bg-black'
                          }
                        `}
                      >
                        {plan.button}
                      </a>
                    ) : (
                      <button data-component-id="src/app/landing-page/components/Pricing.tsx:148:22" data-component-path="src/app/landing-page/components/Pricing.tsx" data-component-line="148" data-component-end-line="159" data-component-file="Pricing.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
                        onClick={onRequestDemo}
                        className={`w-full mb-8 px-6 py-3 rounded-lg font-semibold transition
                          ${
                            isActive
                              ? 'bg-gradient-to-r from-amber-500 to-yellow-400 text-black'
                              : 'bg-gray-800 text-white/90 hover:bg-black'
                          }
                        `}
                      >
                        {plan.button}
                      </button>
                    )}

                    <ul data-component-id="src/app/landing-page/components/Pricing.tsx:162:20" data-component-path="src/app/landing-page/components/Pricing.tsx" data-component-line="162" data-component-end-line="172" data-component-file="Pricing.tsx" data-component-name="ul" data-component-content="%7B%22elementName%22%3A%22ul%22%2C%22className%22%3A%22space-y-4%22%7D" className="space-y-4">
                      {plan.features.map((feature, i) => (
                        <li data-component-id="src/app/landing-page/components/Pricing.tsx:164:24" data-component-path="src/app/landing-page/components/Pricing.tsx" data-component-line="164" data-component-end-line="170" data-component-file="Pricing.tsx" data-component-name="li" data-component-content="%7B%22elementName%22%3A%22li%22%2C%22className%22%3A%22flex%20items-start%20gap-3%22%7D" key={i} className="flex items-start gap-3">
                          {/* ✔ Always green */}
                          <span data-component-id="src/app/landing-page/components/Pricing.tsx:166:26" data-component-path="src/app/landing-page/components/Pricing.tsx" data-component-line="166" data-component-end-line="166" data-component-file="Pricing.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-green-600%20mt-1%22%2C%22textContent%22%3A%22%E2%9C%94%22%7D" className="text-green-600 mt-1">✔</span>
                          <span data-component-id="src/app/landing-page/components/Pricing.tsx:167:26" data-component-path="src/app/landing-page/components/Pricing.tsx" data-component-line="167" data-component-end-line="169" data-component-file="Pricing.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-text-secondary%22%7D" className="text-text-secondary">
                            {feature}
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Pricing;
